export function invoiceCents(value: string): number {
  if (!/^\d+([.,]\d{1,2})?$/.test(value)) return 0;
  const [whole, fraction = ''] = value.replace(',', '.').split('.');
  const cents = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  return Number.isSafeInteger(cents) && cents <= 2147483647 ? cents : 0;
}
export const invoiceDate = (value?: string | null) => value ? new Date(value).toLocaleDateString('pt-BR') : '—';
export const invoiceStatusLabels = { OPEN: 'Em aberto', OVERDUE: 'Vencida', PARTIALLY_PAID: 'Paga parcialmente', PAID: 'Paga', CANCELED: 'Cancelada' };
